import React from 'react';
import posed, {PoseGroup} from 'react-pose';
import {Button, Loading, WaveText} from 'ui-kit';

import * as styles from './FormFooter.module.css';

const StatusAppear = posed.div({
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      x: {ease: 'easeOut'},
    },
  },
  beforeEnter: {
    x: -10,
    opacity: 0,
    transition: {
      x: {ease: 'easeIn'},
    },
  },
  exit: {
    x: 10,
    opacity: 0,
    transition: {
      x: {ease: 'easeIn'},
    },
  },
});

export function FormFooter({status}) {
  return (
    <div className={styles.Container}>
      <Button type="submit" disabled={status === 'loading'}>
        Save
      </Button>

      <div className={styles.Status}>
        <PoseGroup preEnterPose="beforeEnter">
          {status === 'loading' ? (
            <StatusAppear key="loading">
              <Loading />
            </StatusAppear>
          ) : null}
          {status === 'success' ? (
            <StatusAppear key="success">
              <WaveText text="Success!" color="green" />
            </StatusAppear>
          ) : null}
        </PoseGroup>
      </div>
    </div>
  );
}
